"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var Hover =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(Hover, _React$Component);

  function Hover() {
    var _this;

    (0, _classCallCheck2["default"])(this, Hover);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Hover).call(this));
    _this.state = {
      isHovering: false
    };
    _this.toggleHover = _this.toggleHover.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(Hover, [{
    key: "toggleHover",
    value: function toggleHover() {
      this.setState(function (_ref) {
        var isHovering = _ref.isHovering;
        return {
          isHovering: !isHovering
        };
      });
    }
  }, {
    key: "render",
    value: function render() {
      var isHovering = this.state.isHovering;
      var children = this.props.children;
      return _react["default"].createElement("div", {
        onMouseEnter: this.toggleHover,
        onMouseLeave: this.toggleHover
      }, children(isHovering));
    }
  }]);
  return Hover;
}(_react["default"].Component);

exports["default"] = Hover;